import { z } from 'zod'

import { GetUserSchema } from './user.ts'

export const GetCompanyCommentSchema = z.object({
  company_id: z.coerce.number().nullish(),
  content: z.string(),
  created_at: z.coerce.date(),
  id: z.coerce.number(),
  is_modified: z.boolean().nullish(),
  updated_at: z.coerce.date(),
})

export const GetCompanyCommentWithUserSchema = GetCompanyCommentSchema.extend({
  user: GetUserSchema.nullish(),
})
